import { Locale } from 'date-fns';
import * as locale from 'date-fns/locale';
import i18n from '~/i18n';

export function getLocale(): Locale {
    const loc = (locale as any)[i18n.locale];
    return loc || locale.enUS;
}
